import { damagePlayer } from '../damage';
import { wholeTicks } from '../effects';
import type { SpecialModule } from '../specials/types';
import type { PlayerState, SimState } from '../state';

function nearestStanding(state: SimState, at: { x: number; y: number }): PlayerState | undefined {
  let nearest: PlayerState | undefined;
  let best = Infinity;
  for (const player of state.players) {
    const dx = player.x - at.x;
    const dy = player.y - at.y;
    const squared = dx * dx + dy * dy;
    if (!player.downed && squared < best) {
      best = squared;
      nearest = player;
    }
  }
  return nearest;
}

export const sting: SpecialModule = ({ state, tempo }, enemy, effect) => {
  if (effect.kind !== 'sting') {
    return;
  }
  const flight = wholeTicks(effect.flightBeats * tempo.ticksPerBeat);
  const { sting: trail } = enemy;
  if (trail !== undefined) {
    if (state.tick === trail.landTick) {
      const reach = effect.radius * effect.radius;
      for (const player of state.players) {
        const dx = player.x - trail.x;
        const dy = player.y - trail.y;
        if (player.downed || dx * dx + dy * dy > reach) {
          continue;
        }
        damagePlayer(state, player, effect.damage);
        const until = state.tick + effect.slowBars * tempo.ticksPerBar;
        if (player.slowFactorExpiresTick === undefined || until > player.slowFactorExpiresTick) {
          player.slowFactorExpiresTick = until;
          player.slowFactorValue = effect.slowFactor;
        }
        player.slowFactor = Math.min(player.slowFactor ?? 1, effect.slowFactor);
        state.events.push({ type: 'stung', playerId: player.id, x: player.x, y: player.y });
        if (trail.gorged === undefined) {
          trail.gorged = true;
          enemy.hp = Math.min(enemy.maxHp, enemy.hp + effect.heal * enemy.maxHp);
        }
      }
    }
    if (state.tick >= trail.endTick) {
      delete enemy.sting;
    }
    return;
  }
  if (
    !state.events.some((event) => event.type === 'bar') ||
    state.set.bar % effect.everyBars !== effect.everyBars - 1
  ) {
    return;
  }
  const target = nearestStanding(state, enemy);
  if (target === undefined) {
    return;
  }
  enemy.sting = {
    x: target.x,
    y: target.y,
    startTick: state.tick,
    landTick: state.tick + flight,
    endTick: state.tick + 2 * flight,
  };
};
